(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(e) {
      e.preventDefault();
      const { closeAnnouncement } = e.target.dataset;
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove();
      } else {
        this.remove();
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
        this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this));
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterCollapsible extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
      this.openDefault = this.dataset.openDefault === 'true';

      this.details.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      document.addEventListener('matchTablet', this.close.bind(this));
      document.addEventListener('unmatchTablet', this.open.bind(this));

      if (FoxThemeSettings.isTablet) {
        if (!this.openDefault) this.close();
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.close();
        } else {
          this.open();
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open();
      });
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open();
    }

    open() {
      this.details.setAttribute('open', true);
    }

    close() {
      !this.summaryIsEmpty && this.details.removeAttribute('open');
    }
  }

  customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super();
      document.body.classList.add('mobile-sticky-bar-enabled');
      // Matches the markup, which ships without the hidden class.
      // connectedCallback picks the real starting state. Scrolling down reveals
      // the bar, scrolling up hides it. Flip `show` in handleScroll() to invert.
      this.isHidden = false;
      this.barHeight = 0;
      this.lastScrollY = Math.max(window.scrollY, 0);
      this.scrollThreshold = 5;
      this.ticking = false;
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      // Hidden from JS rather than from the markup: if the theme bundle never
      // runs, the bar stays visible and the body keeps its padding fallback,
      // i.e. the behaviour before this feature existed. The transition is
      // suppressed for this first hide so the bar does not animate away on load.
      this.classList.add('mobile-sticky-bar--no-transition');
      this.measure();
      this.toggle(this.isNearBottom());
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.classList.remove('mobile-sticky-bar--no-transition');
        });
      });
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      document.documentElement.style.removeProperty('--f-mobile-navbar-offset');
    }

    measure() {
      // offsetHeight is unaffected by the hide transform, and is 0 while the
      // bar is display:none (>= 768px), which zeroes the offset on desktop.
      this.barHeight = this.offsetHeight;
      document.documentElement.style.setProperty('--f-mobile-navbar-height', this.barHeight + 'px');
      this.syncOffset();
    }

    /* Publishes the height the bar currently occupies so the sticky ATC bar can
       stack on top of it. The body padding-bottom no longer reads this - it is
       reserved at full height regardless of the hide/show state. */
    syncOffset() {
      document.documentElement.style.setProperty(
        '--f-mobile-navbar-offset',
        (this.isHidden ? 0 : this.barHeight) + 'px'
      );
    }

    handleResize() {
      this.measure();
      if (this.isHidden && this.isNearBottom()) this.toggle(true);
    }

    /* The body keeps a constant padding-bottom the height of this bar. That
       strip is only covered while the bar is on screen, so it must stay below
       the fold before the bar is allowed to hide - otherwise scrolling up from
       the end of the page exposes it as an empty gap. */
    isNearBottom() {
      const distanceFromBottom = Math.max(
        document.documentElement.scrollHeight - window.scrollY - window.innerHeight,
        0
      );
      return distanceFromBottom < this.barHeight;
    }

    handleScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        const scrollY = Math.max(window.scrollY, 0);
        const delta = scrollY - this.lastScrollY;
        if (Math.abs(delta) < this.scrollThreshold) return;
        this.lastScrollY = scrollY;
        const show = delta > 0;
        if (!show && this.isNearBottom()) return;
        this.toggle(show);
      });
    }

    toggle(show) {
      const shouldHide = !show;
      if (this.isHidden === shouldHide) return;
      this.isHidden = shouldHide;
      this.classList.toggle('mobile-sticky-bar--hidden', shouldHide);
      this.syncOffset();
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ninemoo-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nm-slideshow')) {
    customElements.define('nm-slideshow', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.tabs = [...this.querySelectorAll('[data-select]')];
        this.index = 0;
        this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.hovered = false;
        this.focused = false;
        this.tabs.forEach((button, index) => button.addEventListener('click', () => { this.show(index); this.start(); }, { signal }));
        this.querySelector('[data-pause]').addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); this.start(); }, { signal });
        this.addEventListener('mouseenter', () => { this.hovered = true; this.start(); }, { signal });
        this.addEventListener('mouseleave', () => { this.hovered = false; this.start(); }, { signal });
        this.addEventListener('focusin', () => { this.focused = true; this.start(); }, { signal });
        this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.start(); }, { signal });
        document.addEventListener('visibilitychange', () => this.start(), { signal });
        document.addEventListener('shopify:block:select', event => { const index = this.slides.findIndex(slide => slide.contains(event.target)); if (index >= 0) { this.paused = true; this.show(index); this.updatePause(); this.start(); } }, { signal });
        this.updatePause();
        this.start();
      }
      show(index) {
        this.index = index;
        this.slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === index); slide.setAttribute('aria-hidden', String(i !== index)); slide.inert = i !== index; this.tabs[i].setAttribute('aria-pressed', String(i === index)); });
      }
      updatePause() {
        this.querySelector('[data-pause]').setAttribute('aria-pressed', String(this.paused));
        this.querySelector('[data-pause-text]').hidden = this.paused;
        this.querySelector('[data-play-text]').hidden = !this.paused;
      }
      start() {
        clearInterval(this.timer);
        if (this.paused || this.hovered || this.focused || document.hidden || this.slides.length < 2) return;
        this.timer = setInterval(() => this.show((this.index + 1) % this.slides.length), Number(this.dataset.interval) || 6000);
      }
      disconnectedCallback() { clearInterval(this.timer); this.controller?.abort(); this.controller = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nm-christmas-home"] && !Shopify.designMode) return;
  try {
    

function nmInitHome(root){
 if(!root||root.dataset.nmReady==='true')return;
 root.dataset.nmReady='true';
 root.querySelectorAll('.nm-carousel').forEach(function(carousel){
  const track=carousel.querySelector('.nm-track');
  if(!track)return;
  const cards=Array.from(track.children);
  const buttons=Array.from(root.querySelectorAll('[data-target="'+carousel.id+'"]'));
  const counter=root.querySelector('#'+carousel.id+'-page');
  function metrics(){
   const gap=parseFloat(getComputedStyle(track).gap)||0;
   const width=cards.length?cards[0].getBoundingClientRect().width:0;
   const step=width+gap;
   const visible=step?Math.max(1,Math.floor((carousel.clientWidth+gap)/step+.01)):1;
   return {step:step,visible:visible,max:Math.max(0,carousel.scrollWidth-carousel.clientWidth)};
  }
  function update(){
   const m=metrics();
   buttons.forEach(function(button){button.disabled=m.max<2||(Number(button.dataset.dir)<0?carousel.scrollLeft<2:carousel.scrollLeft>=m.max-2);});
   if(counter){
    const pages=Math.max(1,Math.ceil(cards.length/m.visible));
    const page=carousel.scrollLeft>=m.max-2?pages:Math.min(pages,Math.floor((carousel.scrollLeft+2)/(m.step*m.visible||1))+1);
    counter.textContent=page+' / '+pages;
   }
  }
  buttons.forEach(function(button){
   button.addEventListener('click',function(event){
    event.preventDefault();
    const m=metrics();
    const target=Math.max(0,Math.min(m.max,carousel.scrollLeft+Number(button.dataset.dir)*m.step*m.visible));
    carousel.scrollTo({left:target,behavior:'smooth'});
   });
  });
  carousel.addEventListener('scroll',update,{passive:true});
  if(typeof ResizeObserver!=='undefined')new ResizeObserver(update).observe(carousel);
  update();
 });
}
function nmBootHome(){document.querySelectorAll('.nm-home').forEach(nmInitHome);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',nmBootHome,{once:true});else nmBootHome();
document.addEventListener('shopify:section:load',function(event){event.target.querySelectorAll('.nm-home').forEach(nmInitHome);});


  } catch(e) { console.error(e); }
})();
})();
